import { Component, Input } from '@angular/core';

@Component({
  selector: 'result-count-badge',
  template: require('./result-count-badge.component.html')
})
export class RelatedResultBadgeComponent {
  @Input() resultCount: number;
}
